import { createTranslations } from '@npco/utils-translations'

export const registerPhoneTranslations = createTranslations({
  rateLimitExceededError:
    'You have exceeded the permitted number of SMS verification. Please try again later.',
})
